import { anonymousBinService } from "./anonymousBinService";
import { preAuthIntent } from "./preAuthIntent";

// Merge anonymous (local) bin items into the authenticated backend bin.
// Does not throw. The local bin is cleared only if every item syncs.
export const mergeAnonymousBinIntoBackend = async (binService) => {
  const items = anonymousBinService.getRawItems();
  if (!items || items.length === 0) return;

  let anyFailed = false;
  for (const item of items) {
    try {
      await binService.addToBin({
        materialId: item.materialId,
        quantity: item.quantity,
      });
    } catch {
      anyFailed = true;
    }
  }

  if (!anyFailed) {
    anonymousBinService.clearBin();
  }
};

export const completePendingAgentAssignment = async ({
  binService,
  navigate,
  setMessage,
}) => {
  const pendingAgentId = preAuthIntent.getPendingAgent();
  if (!pendingAgentId) return;

  try {
    if (setMessage) setMessage("");
    await binService.assignAgent(pendingAgentId);
    preAuthIntent.clearPendingAgent();
    if (navigate) navigate("/sell");
  } catch (error) {
    preAuthIntent.clearPendingAgent();
    if (navigate) navigate("/agents");
    if (setMessage) {
      const msg =
        error?.response?.data?.message ||
        "Failed to assign agent. Please try again.";
      setMessage(msg);
    }
  }
};
